import {useState} from "react";
import {Interpolation, Theme} from "@emotion/react";

import {IRange} from "@pg-design/inputs-module";
import {useUserDevice} from "@pg-mono/user-device";

import {SearchFiltersRooms} from "../../../search/components/filters/SearchFiltersRooms";
import {getRoomLabel} from "../../../search/utils/room_field_data_translations";
import {
    type HitOfferModalFiltersParams,
    trackFilterApply,
    trackFilterClear,
    trackFilterOpenForCategory,
    trackFilterRemove
} from "../../tracking/hit_offer_modal_filters";
import {FakeSelectWithModal} from "./FakeSelectWithModal";

interface IProps {
    initialValue?: IFilterValue;
    rightDropdown?: boolean;
    onConfirm?: (value: IFilterValue) => void;
    handleClear?: () => void;
    aplaCss?: Interpolation<Theme>;
    labelRenderer?: (value: IFilterValue) => Parameters<typeof FakeSelectWithModal>[0]["label"];
    onDropdownOpen?: () => void;
    onDropdownClose?: () => void;
    className?: string;
    trackingParams?: HitOfferModalFiltersParams;
}

type IFilterValue = IRange<number | "">;

const emptyValue: IFilterValue = {lower: "", upper: ""};

export function RoomFilter(props: IProps) {
    const {isMobile} = useUserDevice();
    const {initialValue, onConfirm, handleClear, rightDropdown, className, aplaCss, labelRenderer, onDropdownClose, onDropdownOpen, trackingParams} = props;
    const [value, setValue] = useState<IFilterValue>(initialValue ? initialValue : emptyValue);

    const handlers = {
        confirm: (values: IFilterValue) => {
            if (onConfirm) {
                onConfirm(values);
            }

            if (trackingParams?.eventName && !isMobile) {
                trackFilterApply({
                    eventName: trackingParams.eventName,
                    filterType: "rooms",
                    value: values
                });
            }
        },
        clear: () => {
            if (handleClear) {
                setValue(emptyValue);
                handleClear();
            }
        },
        dropdownOpen: () => {
            if (onDropdownOpen) {
                onDropdownOpen();
            }

            if (!isMobile && trackingParams?.eventName) {
                trackFilterOpenForCategory({filterCategory: "Pokoje", eventName: trackingParams.eventName});
            }
        }
    };

    return (
        <FakeSelectWithModal
            label={labelRenderer ? labelRenderer(value) : getRoomLabel(value, "Pokoje")}
            rightDropdown={rightDropdown}
            isEmpty={!initialValue || (initialValue && initialValue.lower === "" && initialValue.upper === "")}
            onClear={() => {
                if (trackingParams?.eventName && !isMobile) {
                    trackFilterRemove({
                        eventName: trackingParams.eventName,
                        filterType: "rooms",
                        value
                    });
                }
                handlers.clear();
            }}
            onDropdownOpen={handlers.dropdownOpen}
            onDropdownClose={onDropdownClose}
            aplaCss={aplaCss}
            className={className}
        >
            {({close}) => (
                <SearchFiltersRooms
                    value={value}
                    name="rooms"
                    onChange={(_, value) => {
                        setValue(value);
                    }}
                    toggleDropdown={() => {
                        close();
                    }}
                    onSubmitSingle={() => {
                        handlers.confirm(value);
                        close();
                    }}
                    clearField={() => {
                        if (trackingParams?.eventName && !isMobile) {
                            trackFilterClear({
                                eventName: trackingParams.eventName,
                                filterType: "rooms",
                                value
                            });
                        }
                        handlers.clear();
                    }}
                    showFooter
                />
            )}
        </FakeSelectWithModal>
    );
}
import {useState} from "react";
import {Interpolation, Theme} from "@emotion/react";

import {IRange} from "@pg-design/inputs-module";
import {useUserDevice} from "@pg-mono/user-device";

import {SearchFiltersRooms} from "../../../search/components/filters/SearchFiltersRooms";
import {getRoomLabel} from "../../../search/utils/room_field_data_translations";
import {
    type HitOfferModalFiltersParams,
    trackFilterApply,
    trackFilterClear,
    trackFilterOpenForCategory,
    trackFilterRemove
} from "../../tracking/hit_offer_modal_filters";
import {FakeSelectWithModal} from "./FakeSelectWithModal";

interface IProps {
    initialValue?: IFilterValue;
    rightDropdown?: boolean;
    onConfirm?: (value: IFilterValue) => void;
    handleClear?: () => void;
    aplaCss?: Interpolation<Theme>;
    labelRenderer?: (value: IFilterValue) => Parameters<typeof FakeSelectWithModal>[0]["label"];
    onDropdownOpen?: () => void;
    onDropdownClose?: () => void;
    className?: string;
    trackingParams?: HitOfferModalFiltersParams;
}

type IFilterValue = IRange<number | "">;

const emptyValue: IFilterValue = {lower: "", upper: ""};

export function RoomFilter(props: IProps) {
    const {isMobile} = useUserDevice();
    const {initialValue, onConfirm, handleClear, rightDropdown, className, aplaCss, labelRenderer, onDropdownClose, onDropdownOpen, trackingParams} = props;
    const [value, setValue] = useState<IFilterValue>(initialValue ? initialValue : emptyValue);

    const handlers = {
        confirm: (values: IFilterValue) => {
            if (onConfirm) {
                onConfirm(values);
            }

            if (trackingParams?.eventName && !isMobile) {
                trackFilterApply({
                    eventName: trackingParams.eventName,
                    filterType: "rooms",
                    value: values
                });
            }
        },
        clear: () => {
            if (handleClear) {
                setValue(emptyValue);
                handleClear();
            }
        },
        dropdownOpen: () => {
            if (onDropdownOpen) {
                onDropdownOpen();
            }

            if (!isMobile && trackingParams?.eventName) {
                trackFilterOpenForCategory({filterCategory: "Pokoje", eventName: trackingParams.eventName});
            }
        }
    };

    return (
        <FakeSelectWithModal
            label={labelRenderer ? labelRenderer(value) : getRoomLabel(value, "Pokoje")}
            rightDropdown={rightDropdown}
            isEmpty={!initialValue || (initialValue && initialValue.lower === "" && initialValue.upper === "")}
            onClear={() => {
                if (trackingParams?.eventName && !isMobile) {
                    trackFilterRemove({
                        eventName: trackingParams.eventName,
                        filterType: "rooms",
                        value
                    });
                }
                handlers.clear();
            }}
            onDropdownOpen={handlers.dropdownOpen}
            onDropdownClose={onDropdownClose}
            aplaCss={aplaCss}
            className={className}
        >
            {({close}) => (
                <SearchFiltersRooms
                    value={value}
                    name="rooms"
                    onChange={(_, value) => {
                        setValue(value);
                    }}
                    toggleDropdown={() => {
                        close();
                    }}
                    onSubmitSingle={() => {
                        handlers.confirm(value);
                        close();
                    }}
                    clearField={() => {
                        if (trackingParams?.eventName && !isMobile) {
                            trackFilterClear({
                                eventName: trackingParams.eventName,
                                filterType: "rooms",
                                value
                            });
                        }
                        handlers.clear();
                    }}
                    showFooter
                />
            )}
        </FakeSelectWithModal>
    );
}
